import React from "react"

function Logo() {

  return (
    <header className="grid uppercase absolute left-1/2 transform -translate-x-1/2 top-12">
        <h1 className="whitespace-nowrap">
            <a href="/" class="block">Axioms <span className="relative inline-block">&</span> Spurs</a>
        </h1>
        <div className="text-white justify-self-end sm:text-inherit row-start-2">One Thought a Day</div>
        <div className="text-white justify-self-end sm:text-inherit row-start-2col-start-2">Est. 2021</div>
    </header>
  )
}

export default Logo